/**
 * <strong>Purpose:</strong> <br>
 * Provides the ability to override the text of the widget. If an textOverride is provided, its value is what is applied
 * to the DOM instead of the text. If the textOverride is "" then the text is what is applied to the DOM.
 * <br><br>
 * <strong>Contract:</strong> <br>
 * This works in conjunction with the TextMixin. DO mix this in after the TextMixin.
 *
 * @module MW/toolstrip/mixins/property/TextOverrideMixin
 *
 * @copyright Copyright 2015-2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare",
    "MW/toolstrip/constants/MiscConstants",
    "MW/toolstrip/mixins/property/TextMixin"
], function (declare, MiscConstants, TextMixin) {

    var TextOverrideMixin = declare(null, {

        /**
         * @property  {string} textOverride  Supported Values: data-uri / CSS class
         * @instance
         */
        textOverride: "",

        postCreate: function () {
            this.inherited(arguments);

            // Since text's default value is falsy, it will not trigger the setter during the widget construction phase
            // when attributes are being applied we need to call the setter explicitly.
            this.set("textOverride", this.get("textOverride"));
        },

        _setTextAttr: function (text) {
            this.inherited(arguments);

            this._updateNoTextClass();
        },

        _setTextOverrideAttr: function (textOverride) {
            if (typeof textOverride !== "string") {
                throw new Error("'textOverride' property expects a literal string!");
            }

            this._placeTextInNode(textOverride, undefined, "textOverride setter");

            this._set("textOverride", textOverride);

            this._updateNoTextClass();

            if (this._started && this._checkAndFixClippedText) {
                // g2037662: Having a fixed width on the column might cause a part of the widget's text to get clipped
                // off when its orientation is Vertical. This function (defined in OrientationMixin.js) checks for such
                // possibility and fixes the clipped text.
                this._checkAndFixClippedText();
            }
        },

        _updateNoTextClass: function () {
            if (((this.get("textOverride") === "") && (this.get("text") === "")) || (this.get("textOverride") === MiscConstants.DO_NOT_DISPLAY) ) {
                this.domNode.classList.add("mwNoText");
            } else {
                this.domNode.classList.remove("mwNoText");
            }
        },

        _placeTextInNode: function (text, node, origin) {
            if (origin === "textOverride setter") {
                // If input text from "textOverride" setter is DONOTDISPLAY then empty "text" should be applied to the DOM
                if(text === MiscConstants.DO_NOT_DISPLAY) {
                    text = "";
                // If input text from "textOverride" setter is empty then the current "text" should be applied to the DOM
                }  else if (text === "") {
                    text = this.text;
                }
                // If the origin is not the "textOverride setter" then this is being invoked from "text setter"
            } else if (this.textOverride !== "") {
                if(this.textOverride === MiscConstants.DO_NOT_DISPLAY) {
                    text = "";
                } else {
                    text = this.textOverride;
                }
            }

            arguments[0] = text;
            arguments[1] = node;
            this.inherited(arguments);
        }
    });

    TextOverrideMixin._dependencies = [
        {mixin: TextMixin, orderDependent: true}
    ];

    return TextOverrideMixin;

});